import { all } from "typed-redux-saga/macro";

export function* rootSaga() {
  yield* all([]);
}
